import { JSONLoader } from '@loaders.gl/json';
import { load } from '@loaders.gl/core';
import * as turf from '@turf/turf';

export const loadGeoJson = async (geoJsonPathOrData, isJsonData = false) => {
    const geoJsonData = isJsonData
      ? geoJsonPathOrData
      : await load(geoJsonPathOrData, JSONLoader);
  if (!geoJsonData || !geoJsonData.features || geoJsonData.features.length === 0) {
      console.error('Invalid GeoJson data');
      return { geoJsonData: null, cent_long: null, cent_lat: null };
  }
  
  const centroid = turf.centroid(geoJsonData);
  const cent_long = centroid.geometry.coordinates[0];
  const cent_lat = centroid.geometry.coordinates[1];

  return { geoJsonData, cent_long, cent_lat };
};
  